export default "__VITE_ASSET__cpxaO6C$__"